module.exports = __webpack_public_path__ + "img/features01-01.ee6b8b7.png";